export default {
  jobAdvertisement: (state) => {
    return state.jobAdvertisement;
  },
  jobAdvertisementById: (state) => {
    return state.jobAdvertisementById;
  },

  degree: (state) => {
    return state.degree;
  },
  degreeOptions: (state) => {
    const degreeOptions = [];
    state.degree.forEach(func);
    function func(item) {
      const pushItem = {
        id: item.id,
        label: item.title,
      };
      degreeOptions.push(pushItem);
    }
    return degreeOptions;
  },

  collaborationType: (state) => {
    return state.collaborationType;
  },
  collaborationTypeOptions: (state) => {
    const collaborationTypeOptions = [];
    state.collaborationType.forEach(func);
    function func(item) {
      const pushItem = {
        id: item.id,
        label: item.title,
      };
      collaborationTypeOptions.push(pushItem);
    }
    return collaborationTypeOptions;
  },

  companyField: (state) => {
    return state.companyField;
  },
  companyFieldOptions: (state) => {
    const companyFieldOptions = [];
    state.companyField.forEach(func);
    function func(item) {
      const pushItem = {
        id: item.id,
        label: item.title,
      };
      companyFieldOptions.push(pushItem);
    }
    return companyFieldOptions;
  },

  jobRequest: (state) => {
    return state.jobRequest;
  },
  jobRequestById: (state) => {
    return state.jobRequestById;
  },

  socialNetwork: (state) => {
    return state.socialNetwork;
  },
  socialMediaOptions: (state) => {
    const socialMediaOptions = [];
    state.socialNetwork.forEach(func);
    function func(item) {
      const pushItem = {
        id: item.id,
        label: item.title,
      };
      socialMediaOptions.push(pushItem);
    }
    return socialMediaOptions;
  },

  // Static Getters ---------------------------------------------------------------
  genderOptions() {
    return [
      { id: 1, label: "آقا" },
      { id: 2, label: "خانم" },
    ];
  },
};
